import { RootPage } from '../page';
import $api from '../../api';

class SignInView extends RootPage {
    constructor() {
        super();

        this.email = ko.observable();
        this.password = ko.observable();

        this.invitationCode = ko.observable();

        this.signInProblem = ko.observable(false);
    }

    linkedin() {
        window.location.href = '/account/sign-provider?provider=LinkedIn';
    }

    submitSignIn() {
        this.startSubmitting();

        $api.account.signIn({}, { email: this.email(), password: this.password(), invitationCode: this.invitationCode() }, (resp) => {
            this.stopSubmitting();
            //console.log('resp.authStatus', resp.authStatus);
            if (resp.authStatus === 3) {
                window.location.href = '/account/accept-invitation?code=' + this.invitationCode();
            } else if (resp.authStatus !== 0) {
                this.signInProblem(true);
            } else {
                TRACK_DELAYED_EVENT('Users', 'Sign In', { isMobile: window.isMobileBrowser() });

                const searchParams = new URLSearchParams(window.location.search);
                if (searchParams.has('ReturnUrl')) {
                    window.location.href = searchParams.get('ReturnUrl');
                } else {
                    window.location.href = '/';
                }
            }
        });
    }
}

export default SignInView;